export enum AppEnv {
  Alpha = 'alpha',
  Qa = 'qa',
  Uat = 'uat',
  Prod = 'prod'
}
